/**
 * Fetches a full system backup from the server.
 * Returns a blob for downloading.
 */
export const downloadBackup = async (apiClient) => {
  const response = await apiClient.get('/database/backup', {
    responseType: 'blob'
  });
  return response.data;
};

/**
 * Uploads a .sql backup file to the server for restoration.
 */
export const restoreDatabase = async (apiClient, file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await apiClient.post('/database/restore', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

/**
 * Fetches a full system migration package (DB + Files).
 * Returns a blob for downloading.
 */
export const downloadMigrationPackage = async (apiClient) => {
  const response = await apiClient.get('/database/migration-package', {
    responseType: 'blob',
    timeout: 0 // No timeout for large system bundles
  });
  return response.data;
};
